import React from 'react';

import ButtonLink from '@dashboard/components/mui-atoms/ButtonLink';
import TableHeader, { Props as TableHeaderProps } from '@dashboard/components/table/TableHeader';
import { useGroupsListHref } from '@dashboard/hooks/route/hrefs';
import { useSetCurrentPage } from '@dashboard/hooks/route/useCurrentPage';
import { GroupRemoveOutlined } from '@mui/icons-material';

import useCurrentContacts from './useCurrentContacts';

export default function PageHeader() {
  const { data } = useCurrentContacts();
  const setPage = useSetCurrentPage();
  const groupsHref = useGroupsListHref();

  const props: TableHeaderProps = {
    setPage,
    title: 'Contacts',
    actions: (
      <ButtonLink href={groupsHref} startIcon={<GroupRemoveOutlined />} color="secondary" size="small">
        Unsubscribe groups
      </ButtonLink>
    ),
  };

  const model = data?.Contacts;
  if (model === undefined) {
    return <TableHeader {...props} />;
  }

  const count = model.count;
  const limit = model.meta.limit;
  const currentPage = model.meta.page;
  return <TableHeader currentPage={currentPage} limit={limit} count={count} {...props} />;
}
